/**
 * https://www.pdftron.com/api/web/Core.DocumentViewer.html#getAnnotationManager__anchor
 */
export default () => window.documentViewer.getAnnotationManager();
